import { render, staticRenderFns } from "./OrderViewActionCancelOrRefuse.vue?vue&type=template&id=64cc4935&scoped=true&"
import script from "./OrderViewActionCancelOrRefuse.vue?vue&type=script&lang=js&"
export * from "./OrderViewActionCancelOrRefuse.vue?vue&type=script&lang=js&"
import style0 from "./OrderViewActionCancelOrRefuse.vue?vue&type=style&index=0&id=64cc4935&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cc4935",
  null
  
)

export default component.exports